﻿import {JSX, MouseEvent, ReactNode, useCallback, useEffect, useRef} from "react";

export type DialogProps = {
	title: ReactNode;
	children?: ReactNode;
	ref?: React.RefObject<HTMLDialogElement | null>;
	onClose?: (returnValue?: string) => void;
} & React.ComponentPropsWithoutRef<"dialog">;

function closeDialog(evt: MouseEvent<HTMLDialogElement>): void {
	const dialog = evt.target as HTMLDialogElement;
	if (dialog.nodeName === "DIALOG") {
		evt.preventDefault();
		dialog.close("--dismiss");
	}
}

export default function Dialog(props: DialogProps): JSX.Element {
	const {title, children, ref, onClose, ...rest} = props;
	const internalRef = useRef<HTMLDialogElement>(null);
	const dialogRef = ref || internalRef;
	const onCloseHandler = useCallback(() => {
		const returnValue = ref?.current?.returnValue;
		onClose?.(returnValue === "--dismiss" ? undefined : returnValue);
	}, [onClose, dialogRef])

	useEffect(() => {
		if (dialogRef.current) {
			dialogRef.current.showModal();
		}
	}, [dialogRef]);

	return <dialog role="alertdialog" {...rest} onClick={closeDialog} ref={dialogRef} onClose={onCloseHandler}>
		<form method="dialog">
			<header>
				<span>{title}</span>
				<button type="submit" className="material-symbols-rounded">close</button>
			</header>
			<section>{children}</section>
		</form>
	</dialog>;
};
